export default __webpack_public_path__ + "static/media/Masary.d9afad1b.png";